import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

// Components
import DashedLine from '../DashedLine'

// Lib MISC
import styles from './style.scss'

const cx = classnames.bind(styles)

export const propTypes = {
  index: PropTypes.number,
  icon: PropTypes.node,
  title: PropTypes.string,
  item: PropTypes.array,
  hasDot: PropTypes.bool,
  currentSection: PropTypes.number,
  isActived: PropTypes.bool,
}

const defaultProps = {
  isActived: false,
}

function FeatureItem(props) {
  const { index, icon, title, item, hasDot, currentSection, isActived } = props

  const shouldShowItem = currentSection >= index

  return (
    <div className={cx('feature-item')} data-id={index}>
      <div className={cx('feature-item-wrapper')} data-is-actived={isActived} data-is-shown={shouldShowItem}>
        <div className={cx('feature-item-wrapper__left')}>
          <img className={cx('feature-item-wrapper__left-icon')} src={icon} />
          <DashedLine />
        </div>
        <div className={cx('feature-item-wrapper__content')}>
          <p className={cx('feature-item-wrapper__content-title')} data-is-actived={isActived}>
            {title}
          </p>
          {item.map((item, index) => {
            return (
              <div className={cx('feature-item-wrapper__content-item')} key={index}>
                {hasDot && (
                  <div className={cx('feature-item-wrapper__content-item-dot')}>
                    <div className={cx('feature-item-wrapper__content-item-dot-circle')} />
                  </div>
                )}
                <p className={cx('feature-item-wrapper__content-item-text')}>{item}</p>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

FeatureItem.propTypes = propTypes
FeatureItem.defaultProps = defaultProps

export default FeatureItem
